import React, { useEffect, useState, useLayoutEffect, useRef, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import {
    GetMethodData,
    DecryptAESdata, GetPostMethodData
} from "../../../provider/ServiceProvider";
import "./BranchLocator.css";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import imdiamap from '../../../images/india-map.png'
import mappinblue from '../../../images/map-pin-blue.png'
import mappinred from '../../../images/map-pin-red.png'
import { Col, Container, Row } from 'react-bootstrap';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_indiaHigh from '@amcharts/amcharts5-geodata/indiaHigh';
import amccallogo from '../../../images/amc_logo-call.png'
import locationlogo from '../../../images/amc_logo-location.png'
import Button from "@mui/material/Button";
import { Vortex } from 'react-loader-spinner';
import animation from '../../../images/jm-animation.gif';
import Select from 'react-select';
import GetInTouch from "../GetInTouch/GetInTouch";
import { useLocation } from "react-router-dom";


function BranchLocator() {

    const { BaseURL, BaseURLShare } = useContext(URLstateContext);

    const [data, setData] = useState("");
    const [zone, setzone] = useState('');
    const [citys, setCitys] = useState("");
    const [DataCities, setDataCities] = useState([]);
    const [DataCitiesdrop, setDataCitis] = useState([]);
    const [option, setOption] = useState(null);

    const [dataform, setDataForm] = useState([]);
    const [isCityShown, setIsCityShown] = useState(false);
    const [valueEmail, setValueEmail] = useState('');
    const [value, setValue] = useState("");
    const [emailError, setEmailError] = useState('');
    const [valueName, setValueName] = useState('');
    const [nameError, setNameError] = useState('');
    const [valueMob, setValueMob] = useState('');
    const [mobError, setMobError] = useState('');
    const [valueCity, setValueCity] = useState('');
    const [cityError, setCityError] = useState('');
    const [valueComments, setValueComments] = useState('');
    const [CommentsError, setCommentsError] = useState('');
    const [valueState, setValueState] = useState([]);
    const [stateError, setStateError] = useState('');
    const [showInvestorForm, setShowInvestorForm] = useState(true);
    const [showPartnerForm, setShowPartnerForm] = useState(false);
    const [loadingshow, setloadingshow] = useState(false);
    const [selectedCity, setSelectedCity] = useState('');
    const reachus = useRef();
    const location = useLocation();


    const handleInvestorButtonClick = () => {
        setShowInvestorForm(true);
        setShowPartnerForm(false);
    }
    const handlePartnerButtonClick = () => {
        setShowInvestorForm(false);
        setShowPartnerForm(true);
    }

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetJmDrop", {
            "IVzone": zone,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setDataCitis(DecryptAESdata(data.data));
                setloadingshow(false);
            }
        });
    }, [BaseURL, zone]);
    useEffect(() => {
        GetPostMethodData(BaseURL + "GetCityState", {
            IVcity: valueCity,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
            }
        });
    }, [BaseURL, valueCity]);
    let cityOptions = [];

    if (Array.isArray(DataCitiesdrop)) {
        cityOptions = DataCitiesdrop.map(({ city }) => ({
            value: city,
            label: city,
        }));
    }


    const getDistinctCities = () => {
        return DataCitiesdrop?.reduce((uniqueCities, city) => {
            if (!uniqueCities?.includes(city.city)) {
                uniqueCities?.push(city.city);
            }
            return uniqueCities;
        }, []);
    };

    cityOptions = (getDistinctCities() || []).map((city) => ({
    value: city,
    label: city,
}));
    cityOptions.unshift({ value: '', label: 'All Cities' });

    const handleCityChange = (selectedOption) => {
        setOption(selectedOption)
        setCitys(selectedOption.value)
        GetPostMethodData(BaseURL + "GetJmfBranchaes", {
            "IVbranchtype": '',
            "IVzone": zone,
            "IVcity": citys
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                var mainChartDiv = document.getElementById("mainChartDiv")
                mainChartDiv.innerHTML = ""
                var chartdiv = document.createElement("div");
                chartdiv.id = "chartdiv"
                mainChartDiv.appendChild(chartdiv);
                IndiaChart(DecryptAESdata(data.data));
                onchangedata(DecryptAESdata(data.data))
                setDataCities(DecryptAESdata(data.data))
                setloadingshow(false);
            }

        }, [BaseURL, citys, zone]);


    };
    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetJmfBranchaes", {
            "IVbranchtype": '',
            "IVzone": zone,
            "IVcity": citys
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                var mainChartDiv = document.getElementById("mainChartDiv")
                mainChartDiv.innerHTML = ""
                var chartdiv = document.createElement("div");
                chartdiv.id = "chartdiv"
                mainChartDiv.appendChild(chartdiv);
                IndiaChart(DecryptAESdata(data.data));
                onchangedata(DecryptAESdata(data.data))
                setDataCities(DecryptAESdata(data.data))
                setloadingshow(false);
            }

        });
    }, [BaseURL, citys, zone]);


    const onchangedata = (data) => {
        if (citys != '' && zone != '') {
            GetPostMethodData(BaseURL + "GetJmfBranchaes", {
                "IVbranchtype": '',
                "IVzone": zone,
                "IVcity": citys
            }).then((data) => {
                if (data.data != null && data.data.length > 0) {
                    setDataCities(DecryptAESdata(data.data))
                }


            });
        }
    }
    const changeMap = (t_data) => {
        setzone()
        setCitys()

        var mainChartDiv = document.getElementById("mainChartDiv")
        mainChartDiv.innerHTML = ""
        var chartdiv = document.createElement("div");
        chartdiv.id = "chartdiv"
        mainChartDiv.appendChild(chartdiv);
        IndiaChart(t_data)

    }
    useLayoutEffect(() => {

        am5.addLicense("AM5C420959785");
        am5.addLicense("AM5M420959785");
    })

    const IndiaChart = (t_data) => {

        var root = am5.Root.new("chartdiv");
        am5.addLicense("AM5M420959785");
        am5.addLicense("AM5M420959785");
        // Set themes
        root.setThemes([
            am5themes_Animated.new(root)


        ]);


        var chart = root.container.children.push(
            am5map.MapChart.new(root, {
                panX: "none",
                panY: "none",
                wheelY: "none",
                projection: am5map.geoNaturalEarth1(),
                rotationZ: -16,
                panX: "rotateX",
                // panY: "rotateY",
                wheelY: "zoom",
                minZoomLevel: 0.5,
                maxZoomLevel: 16

            })
        );

        // Create polygon series
        var polygonSeries = chart.series.push(
            am5map.MapPolygonSeries.new(root, {
                geoJSON: am5geodata_indiaHigh,
                fill: am5.color(0xd9d9d9),
                stroke: am5.color(0xffffff),

                // tooltip: am5.Tooltip.new(root, {
                //     pointerOrientation: "horizontal"
                //   })
                //exclude: ["AQ"]
            })
        );
        chart.seriesContainer.events.disableType("doublehit");

        // polygonSeries.mapPolygons.template.setAll({
        //     // tooltipText: "{name}",
        //     tooltipHTML: `<span style=color:#fff;font-size:15px">{name}</span>`,
        //     interactive: true,
        // });

        // polygonSeries.mapPolygons.template.states.create("hover", {
        //     fill: am5.color(0x13589A)
        // });


        // Create point series for markers
        // https://www.amcharts.com/docs/v5/charts/map-chart/map-point-series/
        var pointSeries = chart.series.push(am5map.MapPointSeries.new(root, {}));

        pointSeries.bullets.push(function () {

            var circle = am5.Picture.new(root, {
                // radius: 4,
                tooltipY: 4,
                src: "/markepink.png",
                dy: -17,
                dx: -7,
                fill: am5.color(0xf6948b),
                stroke: root.interfaceColors.get("background"),
                opacity: 1,
                tooltipHTML: `<div style="width: 200px; overflow-wrap: break-word;color:#fff; font-size:14px;font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";">
            <span style=color:#fff;font-size:17px">{title}</span><br>
            {description}
                </div>`,

                // tooltipText:"asdasd",


                // populateText: true,
                // interactive: true, 
                // tooltipPosition: "fixed",
                // keepTargetHover: true
                // "State: {title}<br>Population: {description}"
            });
            circle.events.on("click", function (ev) {
                // cursorMoved(ev.target.dataItem)
            });
            return am5.Bullet.new(root, {
                sprite: circle,


            });
        });

        var cities = t_data

        for (var i = 0; i < cities.length; i++) {
            var city = cities[i];
            addCity(city.longitude, city.latitude, city.branchname, city.address);
        }

        function addCity(longitude, latitude, title, description) {
            pointSeries.data.push({
                geometry: { type: "Point", coordinates: [longitude, latitude] },
                title: title,
                description: description,
                // populateText: true,
            });
        }

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/charts/map-chart/map-pan-zoom/#Zoom_control
        // chart.set("zoomControl", am5map.ZoomControl.new(root, {}));
        const zoomControl = am5map.ZoomControl.new(root, {});

        chart.set("zoomControl", zoomControl);

        // + and - button background
        zoomControl.plusButton.setAll({
        background: am5.RoundedRectangle.new(root, {
            fill: am5.color(0x013c66), // 
            cornerRadiusTL: 4,
            cornerRadiusTR: 4,
            cornerRadiusBL: 4,
            cornerRadiusBR: 4,
            stroke: am5.color(0x013c66),
        }),
        });

        zoomControl.minusButton.setAll({
        background: am5.RoundedRectangle.new(root, {
            fill: am5.color(0x013c66), //
            cornerRadiusTL: 4,
            cornerRadiusTR: 4,
            cornerRadiusBL: 4,
            cornerRadiusBR: 4,
            stroke: am5.color(0x013c66),
        }),
        });

        // Change the + and - icon color
        zoomControl.plusButton.get("icon").setAll({
        fill: am5.color(0x000000), // Black
        });

        zoomControl.minusButton.get("icon").setAll({
        fill: am5.color(0x000000), // Black
        });

        chart.appear(1000, 100);
    }

    function showInMapClicked(longitude, latitude, address) {
        window.open("https://maps.google.com?q=" + longitude + "," + latitude + "," + address);

    }

    // Get all elements with the class "action-button"
    var actionButtons = document.querySelectorAll('.action-button');

    // Loop through each action button and add a click event listener
    actionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            // Toggle the "active" class on the clicked element
            this.classList.toggle('active');
        });
    });

    return (
        <>
            {/* <div id="chartdiv"></div> */}
            <main className="amc-branches-main">
                <Container>
                    <Row>
                        <h2>Our branches across the country</h2>
                        <Col lg={7} md={6} sm={12}>
                            <div className="map-container">
                                <div id="mainChartDiv">
                                    <div id="chartdiv"></div>

                                </div>

                            </div>
                        </Col>
                        <Col lg={5} md={6} sm={12} className=' kfin-branches-section jm-branch-section'>
                            <div className="kfin-branches-container">
                                <div className="across-country-container">
                                    <div className="across-country-tabs">
                                        <div className="tab-list" id="zone-button">
                                            <button value="" className={(zone === "") ? "active" : ''} onClick={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}>All</button>
                                            <button value="North" className={(zone === "North") ? "active" : ''} onClick={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}> North</button>
                                            <button value="East" className={(zone === "East") ? "active" : ''} onClick={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}>East</button>
                                            <button value="West" className={(zone === "West") ? "active" : ''} onClick={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}>West</button>
                                            <button value="South" className={(zone === "South") ? "active" : ''} onClick={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}>South</button>
                                        </div>
                                        <div className="select-container" id="zone-drop">
                                            <select className="fund-selector" onChange={(event) => { setzone(event.target.value); setCitys(''); setOption(null) }}>
                                                <option value="">All</option>
                                                <option value="North">North</option>
                                                <option value="East">East</option>
                                                <option value="West">West</option>
                                                <option value="South">South</option>
                                            </select>

                                        </div>

                                        <div className="select-container">
                                            <label htmlFor="branch-drop-input">City</label>
                                           <Select
                                            id="branch-drop"                    // ← Add this
                                            inputId="branch-drop-input"         // Better to separate inputId
                                            instanceId="branch-drop"
                                            className=""
                                            options={cityOptions}
                                            isSearchable
                                            placeholder="Search for a city or select from the list..."
                                            onChange={handleCityChange}
                                            value={option}
                                            aria-label="Select City"
                                        />
                                        </div>

                                        <div className="location fixed-height-city"   tabIndex="0" aria-label="Branch locations list" role="region">
                                            {/* {(DataCities === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                                            {loadingshow ? (
                                                <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                                                    <img src={animation} alt="" aria-hidden="true" />
                                                    <div className="model_popup">Please Wait...</div>
                                                </div>
                                            ) : (
                                                <div>
                                                    {DataCities.length === 0 ? (
                                                        <h5 className="errormsgComNew" role="alert">No Data Available</h5>
                                                    ) : (
                                                        <>
                                                            {DataCities && DataCities.map(({ branchname, address, landline, latitude, longitude, Type }) => (
                                                                <div className="location">
                                                                    <div className="city-name">
                                                                        {branchname}

                                                                        <div className="opt-button">
                                                                        <span>{Type}</span>
                                                                    </div>
                                                                    </div>
                                                                    {/* <div>
                                                                        {Typedescrip && (
                                                                                <span className="type-desc"> ({Typedescrip})</span>
                                                                            )}
                                                                    </div> */}

                                                                    <div className="add-call-container">
                                                                        <div className="address">
                                                                            <div className="logo-container">
                                                                                <img src={locationlogo} alt="locationlogo" />
                                                                                <p>{address}</p>
                                                                            </div>

                                                                        </div>
                                                                        {landline && <div className="call">
                                                                            <div className="logo-container">
                                                                                <img src={amccallogo} alt="amccallogo" />
                                                                                <p>{landline}</p>
                                                                            </div>

                                                                        </div>}

                                                                    </div>
                                                                    <div className="btn-locateus">
                                                                        <button onClick={() => showInMapClicked(latitude, longitude, address)} aria-label={`Locate ${branchname}`}>Locate Us</button>
                                                                    </div>
                                                                </div>

                                                            )
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                            {/* {loadingshow ? <div className="textcentervertex">

                                                <img src={animation} alt="Loading" />
                                                <div className="model_popup">Please Wait...</div>
                                            </div> : ""
                                            } */}
                                            {/* {DataCities === null ? (
                                                <div className="textCenter">

                                                    <h5>No Data Found...</h5>
                                                </div>
                                            ) : (
                                                ""
                                            )} */}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div class="sticky-icon">
                        <div id="fixed-social">
                            <div>
                                <div class="fixed-instagrem box" target="_blank"><i class="fa fa-phone-square" style={{color : "#fff"}}></i>
                                    <span >
                                        <a href="tel:1800 1038 345" className="hover-contact">
                                            1800 1038 345
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div class="fixed-tumblr box">
                                    <i class="fa fa-envelope"></i>
                                    <span style={{color : "#000"}}>
                                        <a href="mailto:investor@jmfl.com">investor@jmfl.com</a>
                                    </span>
                                    <br></br>
                                    <span style={{color : "#000"}}>
                                        <a href="mailto:partnercare@jmfl.com" style={{color : "#000"}}>
                                            partnercare@jmfl.com
                                        </a>
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                </Container>

                {/* <GetInTouch /> */}





                <GetInTouch ref={reachus} />




            </main >

        </>
    )
}

export default BranchLocator